import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UniversityListComponent } from './university-list/university-list.component';
import { UniversityCreateComponent } from './university-create/university-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: UniversityListComponent,
        data: {
          title: "University List",
          breadcrumb: "University List"
        }
      },
      {
        path: 'create',
        component: UniversityCreateComponent,
        data: {
          title: "Create University",
          breadcrumb: "Create University"
        }
      },
      {
        path: 'edit/:id',
        component: UniversityCreateComponent,
        data: {
          title: "Edit University",
          breadcrumb: "Edit University"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class UniversityRoutingModule { }
